import api from './api';

const ENDPOINT = 'units';

const UnitService = {
  get: (params = null) => api.get(ENDPOINT, { params }),
  getId: (id) => api.get(`${ENDPOINT}/${id}`),
  save: (data) => api.post(`${ENDPOINT}`, data),
  update: (id, data) => api.put(`${ENDPOINT}/${id}`, data),
  delete: (id) => api.delete(`${ENDPOINT}/${id}`),
};

export default UnitService;
